import { config } from "config";
const brokerHelper = {};

brokerHelper.getLogoUrl = () => {
    const brokerName = window.location.hostname.split(".")[0];
    const brokers = config.broker;
    const broker = brokers[brokerName] || {};
    return broker.logoUrl;

};

// Brokers whose login is a popup inside the app (no external redirect, no smallcase SDK).
// These can open on the current screen instead of the /customer/broker page.
brokerHelper.isInAppLoginBroker = (brokerPlatform) => {
    const { platform } = config.broker;
    return [
        platform.arham,
        platform.bigul,
        platform.kambala,
        platform.navia,
        platform.saral,
        platform.symphony,
        platform.tradecircle,
    ].includes(brokerPlatform);
};

export { brokerHelper };
